import { BreachEvent, click_origin_breach_screen } from '@news-mono/web-common'
import React from 'react'
import { IconStar } from '../../../../icons/IconStar/IconStar'
import { AuthenticationProvider } from '../../../../user-registration/authentication/AuthenticationProvider'
import { createLinkClickEvent } from '../../createLinkClickHandler'
import {
    Ribbon,
    StyledPackageImage,
    StyledSubscriptionPackage,
    StyledSubscriptionPackageActions,
    StyledSubscriptionPackageButton,
    StyledSubscriptionPackageHeading,
    StyledSubscriptionPackageOriginalPrice,
    StyledSubscriptionPackagePreTitle,
    StyledSubscriptionPackagePrice,
    StyledSubscriptionPackagePriceQualifier,
} from './SubscriptionPackage.styled'

const everyDayDigitalImage = require('./images/everyday_digital.png')
const everyDayNewspaperImage = require('./images/everyday_digital_newspaper.png')

export interface SubscriptionPackageProps {
    pretitle: string
    originalPrice?: string
    heading: string
    price: string
    priceQualifier?: string
    ribbonTitle?: string
    packagePath: string
    offerCode?: string
    packageType?: 'digital' | 'digitalprint'
    breachCreativeName: string
    breachDeal: string
    packageTheme?: 'default' | 'red'
    onEvent: (event: BreachEvent) => void
}

export const SubscriptionPackage: React.FC<SubscriptionPackageProps> = ({
    pretitle,
    heading,
    originalPrice,
    price,
    priceQualifier,
    ribbonTitle,
    packagePath,
    breachDeal,
    offerCode,
    breachCreativeName,
    packageTheme = 'default',
    onEvent,
    packageType,
}) => (
    <AuthenticationProvider onEvent={onEvent}>
        {({ onSubscribeClick }) => (
            // Note: There is high editorial care factor on these images, please ensure
            // appropriate approvals have happened before replacing or updating
            <StyledSubscriptionPackage packageTheme={packageTheme}>
                {packageType === 'digital' && (
                    <StyledPackageImage
                        src={everyDayDigitalImage}
                        alt=""
                        role="presentation"
                    />
                )}

                {packageType === 'digitalprint' && (
                    <StyledPackageImage
                        src={everyDayNewspaperImage}
                        alt=""
                        role="presentation"
                    />
                )}
                <StyledSubscriptionPackagePreTitle packageTheme={packageTheme}>
                    {pretitle}
                </StyledSubscriptionPackagePreTitle>
                <StyledSubscriptionPackageHeading packageTheme={packageTheme}>
                    {heading}
                </StyledSubscriptionPackageHeading>
                {originalPrice && (
                    <StyledSubscriptionPackageOriginalPrice
                        packageTheme={packageTheme}
                    >
                        {originalPrice}
                    </StyledSubscriptionPackageOriginalPrice>
                )}
                <StyledSubscriptionPackagePrice packageTheme={packageTheme}>
                    {price}
                </StyledSubscriptionPackagePrice>
                {priceQualifier && (
                    <StyledSubscriptionPackagePriceQualifier
                        packageTheme={packageTheme}
                    >
                        {priceQualifier}
                    </StyledSubscriptionPackagePriceQualifier>
                )}
                {ribbonTitle && (
                    <Ribbon packageTheme={packageTheme}>
                        <span>
                            <IconStar />
                            {ribbonTitle}
                        </span>
                    </Ribbon>
                )}
                <StyledSubscriptionPackageActions>
                    <StyledSubscriptionPackageButton
                        packageTheme={packageTheme}
                        buttonWidth="wide"
                        onClick={() => {
                            createLinkClickEvent(
                                breachCreativeName,
                                breachDeal,
                                onEvent,
                            )()
                            onSubscribeClick({
                                packagePath,
                                offerCode,
                                callToAction: click_origin_breach_screen,
                            })
                        }}
                    >
                        Subscribe Now
                    </StyledSubscriptionPackageButton>
                </StyledSubscriptionPackageActions>
            </StyledSubscriptionPackage>
        )}
    </AuthenticationProvider>
)

SubscriptionPackage.displayName = 'SubscriptionPackage'

export default SubscriptionPackage
